import axios from "axios";
import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
// import { toast } from "react-toastify";
import { FaCalendarAlt, FaWallet, FaRupeeSign } from "react-icons/fa";
import { FiMoreHorizontal, FiArrowLeft, FiArrowRight } from "react-icons/fi";
import { ChevronDown } from "lucide-react";
import { DateRange } from 'react-date-range';
import dayjs from "dayjs";
import Cookies from "js-cookie"
import ThreeDotLoader from "../../Loader";
import {Notification} from "../../Notification"

const WalletHistory = ({
  setFiltersApplied,
  clearFiltersTrigger,
  setClearFiltersTrigger,
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(20); // default 20
  const [transactions, setTransactions] = useState([]);
  const [filters, setFilters] = useState({});
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const REACT_APP_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
  const [dateRange, setDateRange] = useState("");
  const [status, setStatus] = useState("");
  const [paymentId, setPaymentId] = useState("");

  const [customDateLabel, setCustomDateLabel] = useState('');
  const [transactionId, setTransactionId] = useState("");
  const dateDropdownRef = useRef()
  const [showDateDropdown, setShowDateDropdown] = useState(false);
  const [showStatusDropdown, setShowStatusDropdown] = useState(false);
  const [customRange, setCustomRange] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);
  const [showCalendar, setShowCalendar] = useState(false);
  const calendarRef = useRef();
  const statusRef = useRef();

  const getDateRange = () => {
    const today = dayjs();
    switch (dateRange) {
      case "today":
        return {
          fromDate: today.startOf("day").toISOString(),
          toDate: today.endOf("day").toISOString(),
        };
      case "yesterday":
        return {
          fromDate: today.subtract(1, "day").startOf("day").toISOString(),
          toDate: today.subtract(1, "day").endOf("day").toISOString(),
        };
      case "last5days":
        return {
          fromDate: today.subtract(5, "day").startOf("day").toISOString(),
          toDate: today.endOf("day").toISOString(),
        };
      case "thisMonth":
        return {
          fromDate: today.startOf("month").toISOString(),
          toDate: today.endOf("month").toISOString(),
        };
      case "lastMonth":
        const lastMonth = today.subtract(1, "month");
        return {
          fromDate: lastMonth.startOf("month").toISOString(),
          toDate: lastMonth.endOf("month").toISOString(),
        };
      case "custom":
        return {
          fromDate: customRange[0].startDate.toISOString(),
          toDate: customRange[0].endDate.toISOString(),
        };
      default:
        return {};
    }
  };

  const fetchTransactions = async (page = 1, filterData = filters, rowLimit = limit) => {
    try {
      setLoading(true);
      const { fromDate, toDate } = getDateRange();
      const token = Cookies.get("session");
      const params = {
        id,
        transactionId,
        paymentId,
        status,
        fromDate, toDate
      }
      const response = await axios.get(
        `${REACT_APP_BACKEND_URL}/recharge/transactionHistory?page=${page}&limit=${rowLimit}`,
        {
          params,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log("rre", response)
      setTransactions(response.data.data);
      setTotalPages(response.data.totalPages);
      setLoading(false);
    } catch (error) {
      console.error("Failed to fetch transactions:", error);
      Notification("Failed to fetch transactions.","error");
      setLoading(false);
    }
  };
  const handleApplyCustomDate = () => {
    setShowCalendar(false);
    const start = dayjs(customRange[0].startDate).format("MMM D");
    const end = dayjs(customRange[0].endDate).format("MMM D");

    setCustomDateLabel(`${start} - ${end}`);
    setDateRange("custom"); // Ensure it's always "custom"
    fetchTransactions();
  };
  useEffect(() => {
    fetchTransactions(currentPage, filters, limit);
  }, [currentPage, limit, status, paymentId, transactionId, dateRange]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dateDropdownRef.current && !dateDropdownRef.current.contains(event.target) && statusRef.current && !statusRef.current.contains(event.target)) {
        setShowStatusDropdown(false);
        setShowDateDropdown(false)
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (clearFiltersTrigger) {
      setFilters({});
      setCurrentPage(1);
      fetchTransactions(1, {}, limit);
      setFiltersApplied(false);
      setClearFiltersTrigger(false);
    }
  }, [clearFiltersTrigger]);

  const handleLimitChange = (e) => {
    const selected = e.target.value;
    if (selected === "all") {
      setLimit(10000); // Arbitrary large number to fetch all
    } else {
      setLimit(Number(selected));
    }
    setCurrentPage(1); // Reset to page 1 on limit change
  };
  const handleClearFilters = () => {
    setTransactionId("");
    setPaymentId("");
    setDateRange([{ startDate: null, endDate: null, key: "selection" }]);
    setStatus("")
  }

  return (
    <div className="w-full">
      <div className="flex gap-2 sm:flex-row flex-col mb-2 w-full">
        <div className="flex gap-2 w-full sm:w-auto">
          <input
            type="text"
            placeholder="Search Transaction ID"
            value={transactionId}
            onChange={(e) => setTransactionId(e.target.value)}
            className="px-3 w-full rounded-lg placeholder:text-[12px] text-gray-700 font-[600] text-[12px] placeholder:text-gray-400 border-2 border-gray-300 focus:outline-none h-9"
          />
          {/* Payment ID Filter */}
          <input
            type="text"
            placeholder="Search Payment ID"
            value={paymentId}
            onChange={(e) => setPaymentId(e.target.value)}
            className="px-3 w-full rounded-lg placeholder:text-[12px] text-gray-700 font-[600] text-[12px] placeholder:text-gray-400 border-2 border-gray-300 focus:outline-none h-9"
          />
        </div>

        <div className="flex gap-2 justify-between w-full">
          <div className="flex gap-2 w-full sm:w-auto">
            {/* Date Range Dropdown */}
            <div className="relative w-full" ref={dateDropdownRef}>
              <button
                onClick={() => setShowDateDropdown((prev) => !prev)}
                className="w-full sm:w-40 h-9 p-2 border-2 border-gray-300 rounded-lg sm:text-[12px] text-[12px] bg-white text-gray-400 font-[600] flex items-center justify-between"
                type="button"
              >
                {(() => {
                  if (dateRange === "custom") return customDateLabel || "Custom";
                  const predefinedLabels = {
                    today: "Today",
                    yesterday: "Yesterday",
                    last5days: "Last 5 Days",
                    thisMonth: "This Month",
                    lastMonth: "Last Month",
                  };
                  return predefinedLabels[dateRange] || "Dates";
                })()}
                <ChevronDown className={`w-4 h-4 transform transition-transform ${showDateDropdown ? "rotate-180" : ""}`} />
              </button>


              {showDateDropdown && (
                <ul className="absolute z-30 sm:w-40 w-full mt-1 bg-white border-2 rounded-lg shadow-lg max-h-60 overflow-y-auto text-[12px] text-gray-500 font-[600]">
                  {[
                    // { value: "", label: "Dates" },
                    { value: "today", label: "Today" },
                    { value: "yesterday", label: "Yesterday" },
                    { value: "last5days", label: "Last 5 Days" },
                    { value: "thisMonth", label: "This Month" },
                    { value: "lastMonth", label: "Last Month" },
                    { value: "custom", label: customDateLabel ? `Custom: ${customDateLabel}` : "Custom" }
                  ].map((item) => (
                    <li
                      key={item.value || "default"}
                      className={`px-3 py-2 text-gray-500 font-[600] cursor-pointer hover:bg-purple-100 ${dateRange === item.value ? "bg-purple-100 font-[600]" : ""}`}
                      onClick={() => {
                        setDateRange(item.value);
                        setShowDateDropdown(false);
                        if (item.value === "custom") {
                          setShowCalendar(true);
                        } else {
                          setShowCalendar(false);
                        }
                      }}
                    >
                      {item.label}
                    </li>
                  ))}
                </ul>
              )}

              {/* Calendar Dropdown */}
              {showCalendar && (
                <div
                  ref={calendarRef}
                  className="absolute z-30 mt-2 bg-white shadow-lg rounded-lg p-2 w-[350px]"
                >
                  <DateRange
                    editableDateInputs={true}
                    onChange={(item) => setCustomRange([item.selection])}
                    moveRangeOnFirstSelection={false}
                    ranges={customRange}
                    maxDate={new Date()}
                    showDateDisplay={false}
                  />
                  <button
                    onClick={handleApplyCustomDate}
                    className="w-full mt-2 bg-[#632C9D] text-white text-sm py-1 px-3 rounded hover:bg-purple-600"
                  >
                    Apply
                  </button>
                </div>
              )}
            </div>
            {/* Status Filter */}
            <div className="relative w-full" ref={statusRef}>
              <button
                onClick={() => setShowStatusDropdown((prev) => !prev)}
                className="w-full sm:w-28 h-9 p-2 text-gray-400 border-gray-300 font-[600] border-2 rounded-lg text-left sm:text-[12px] text-[12px] bg-white flex justify-between items-center"
                type="button"
              >
                <span>{status || "Status"}</span>
                <ChevronDown
                  className={`w-4 h-4 transition-transform duration-200 ${showStatusDropdown ? "rotate-180" : ""}`}
                />
              </button>

              {showStatusDropdown && (
                <ul className="absolute z-30 text-gray-500 font-[600] sm:w-28 w-full mt-1 bg-white border-2 rounded-lg shadow max-h-60 overflow-y-auto text-[12px]">
                  {[
                    "success", "failed"
                  ].map((s) => (
                    <li
                      key={s || "empty"}
                      className={`px-3 py-2 cursor-pointer hover:bg-purple-100 ${status === s ? "bg-purple-100 font-[600]" : ""}`}
                      onClick={() => {
                        setStatus(s);
                        setShowStatusDropdown(false);
                      }}
                    >
                      {s || "Status"}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>
          <button
            className="h-9 px-3 sm:w-none text-[10px] sm:text-[12px] border-2 border-gray-100 rounded-lg font-[600] text-white bg-[#632C9D] hover:bg-purple-500 transition whitespace-nowrap"
            onClick={handleClearFilters}
            type="button"
          >
            Clear
          </button>
        </div>
      </div>

      {/* Desktop View (Table Format) */}
      <div className="hidden md:block text-[12px] text-left">
        <table className="w-full bg-white overflow-hidden">
          <thead className="bg-[#632C9D] text-white font-[600] text-[12px]">
            <tr className="border border-[#632C9D]">
              <th className="text-left px-3 py-2">Date</th>
              <th className="text-left px-3 py-2">Transaction Id</th>
              <th className="text-left px-3 py-2">Amount</th>
              <th className="text-left px-3 py-2">Status</th>
              <th className="text-left px-3 py-2">Description</th>
            </tr>
          </thead>
          <tbody className="text-gray-700">
            {loading ? (
              <tr>
                <td colSpan="5">
                  <ThreeDotLoader />
                </td>
              </tr>
            ) : transactions.length > 0 ? (
              transactions.map((row, index) => (
                <tr key={index} className="border border-gray-300 font-[400] text-[12px]">
                  <td className="text-left px-3 py-2" style={{ maxWidth: '300px', width: '200px' }}>
                    <p>{new Date(row.date).toLocaleDateString()}</p>
                    <p>{new Date(row.date).toLocaleTimeString()}</p>
                  </td>
                  <td className="text-left px-3 py-2" style={{ maxWidth: '300px', width: '200px' }}>{row.paymentDetails.transactionId}</td>
                  <td className="text-left px-3 py-2" style={{ maxWidth: '300px', width: '200px' }}>₹{Number(row.paymentDetails.amount).toFixed(2)}</td>
                  <td
                    className={`text-left px-3 py-2 ${row.status.toLowerCase() === "failed"
                      ? "text-red-500"
                      : "text-[#632C9D]"}`} style={{ maxWidth: '300px', width: '200px' }}
                  >
                    {row.status}
                  </td>
                  <td className="text-left px-3 py-2" style={{ maxWidth: '300px', width: '200px' }}>
                    <p>
                      <span className="font-[600]">paymentId:</span>{" "}
                      <span>{row.paymentDetails.paymentId}</span>
                    </p>
                    <p>
                      <span className="font-[600]">OrderId:</span>{" "}
                      <span>{row.paymentDetails.orderId}</span>
                    </p>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className="text-center py-4 text-gray-500">No data available</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Mobile View (Card Format) */}
      <div className="md:hidden">
        {loading ? (
          <ThreeDotLoader />
        ) : transactions.length > 0 ? (
          <div className="space-y-4">
            {transactions.map((row, index) => (
              <div
                key={index}
                className="bg-white rounded-lg text-gray-500 shadow px-4 py-3 border border-gray-200 text-[12px]"
              >
                {/* Top: Date and Status */}
                <div className="flex justify-between items-center mb-2">
                  <span className="text-gray-500">
                    {new Date(row.date).toLocaleString()}
                  </span>
                  <span
                    className={`text-[10px] font-[600] px-2 py-[2px] rounded-lg ${row.status.toLowerCase() === "failed"
                      ? "bg-red-100 text-red-600"
                      : "bg-purple-100 text-purple-600"
                      }`}
                  >
                    {row.status}
                  </span>
                </div>

                {/* Middle: Description */}
                <div className="mb-3">
                  {[
                    { label: "Payment ID", value: row.paymentDetails.paymentId },
                    { label: "Order ID", value: row.paymentDetails.orderId },
                    { label: "Payment Gateway", value: "RZ" },
                  ].map((item, index) => (
                    <div
                      key={index}
                      className="grid grid-cols-[120px_10px_1fr] gap-2 text-gray-600 text-[12px] mb-1"
                    >
                      <span className="font-medium">{item.label}</span>
                      <span className="text-center">:</span>
                      <span className="text-gray-800 text-right break-words">{item.value}</span>
                    </div>
                  ))}
                </div>

                {/* Bottom: Txn ID and Amount */}
                <div className="mt-2 -mx-4 -my-4 px-4 py-2 bg-purple-100 flex justify-between items-center">
                  <div>
                    <span className="font-[600] text-gray-500">Transaction ID:</span><br />
                    <span className="text-gray-500">#{row.paymentDetails.transactionId}</span>
                  </div>
                  <div className="text-right">
                    <span className="font-[600] text-gray-500">Amount:</span><br />
                    <span className="text-gray-700 font-[600]">
                      ₹{Number(row.paymentDetails.amount).toFixed(2)}
                    </span>
                  </div>
                </div>

              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-4 text-gray-500">No data available</div>
        )}
      </div>



      {/* Pagination Controls + Limit Selector */}
      <div className="flex justify-between items-center mt-6 gap-4 flex-wrap text-[10px] font-[600]">
        <div className="flex items-center gap-2">
          <label htmlFor="limit" className="text-gray-700 text-[10px] font-[600]">Show:</label>
          <select
            id="limit"
            value={limit}
            onChange={handleLimitChange}
            className="px-3 py-2 border rounded-md text-[10px] font-[600]"
          >
            <option value={20}>20</option>
            <option value={50}>50</option>
            <option value={75}>75</option>
            <option value={100}>100</option>
            <option value="all">All</option>
          </select>
        </div>

        <div className="flex items-center gap-4">
          <button
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
            className="py-2 px-3 bg-gray-300 rounded disabled:opacity-50"
          >
            <FiArrowLeft />
          </button>
          <span className="text-gray-700">
            Page {currentPage} of {totalPages}
          </span>
          <button
            onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
            disabled={currentPage === totalPages}
            className="py-2 px-3 bg-gray-300 rounded disabled:opacity-50"
          >
            <FiArrowRight />
          </button>
        </div>
      </div>

    </div>
  );
};

export default WalletHistory;
